// 24h customer service window helpers (Meta: the timer resets on every message/call FROM the
// customer; business messages never extend it).

export const CSW_TOTAL_MS = 24 * 3600 * 1000;
const INCOMING = 0;

// Latest customer message timestamp (ms) from the loaded conversation messages.
export const lastIncomingAtMs = (messages = []) => {
  let latest = 0;
  (messages || []).forEach(message => {
    if (message.message_type !== INCOMING || message.private) return;
    if (message.created_at > latest) latest = message.created_at;
  });
  return latest ? latest * 1000 : null;
};

export const cswDeadlineMs = messages => {
  const last = lastIncomingAtMs(messages);
  return last ? last + CSW_TOTAL_MS : null;
};
